import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {HashRouter, Navigate, Route, Routes} from 'react-router-dom';
import {Home} from './pages/Home';
import {MobileApp} from './pages/MobileApp';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HashRouter>
        <Routes>
            <Route path='*' element={<Navigate to='/index' />} />
            <Route path='/index/*' element={<App />} />
            <Route path='/home/*' element={<Home />} />
            <Route path='/mobile/*' element={<MobileApp/>} />
        </Routes>
    </HashRouter>
);

